import { Tooltip } from 'components/tooltip';
import InfoIcon from 'icons/info.svg?react';
import { forwardRef } from 'react';
import { cn } from 'utils/tailwind';

type InfoTooltipProps = {
  text: string;
  className?: string;
  iconClassName?: string;
};

export const InfoTooltip = forwardRef<HTMLDivElement, InfoTooltipProps>(
  ({ text, className, iconClassName }, ref) => (
    <Tooltip asChild text={text}>
      <div
        className={cn('cursor-pointer', className)}
        onClick={(e) => {
          e.stopPropagation();
        }}
        ref={ref}
      >
        <InfoIcon className={cn('text-neutral-300', iconClassName)} />
      </div>
    </Tooltip>
  ),
);

InfoTooltip.displayName = 'InfoTooltip';
